import React from 'react';
import { Section } from './Section';
export function Hook() {
  return <Section darker data-id="element-105">
      <div className="max-w-3xl mx-auto prose prose-invert prose-lg md:prose-xl" data-id="element-106">
        <p className="font-medium leading-relaxed" data-id="element-107">
          Sé exactamente lo que se siente. Estás en el momento de mayor
          intensidad, el corazón te late a mil por hora y, de repente, ese
          "vacío" en el estómago te avisa que ya no hay vuelta atrás.
        </p>
        <p className="font-medium leading-relaxed" data-id="element-108">
          Sucede otra vez: terminó antes de haber empezado realmente.
        </p>
        <p className="font-medium leading-relaxed" data-id="element-109">
          Vuelves a ver esa mirada en ella —una mezcla de decepción oculta tras
          una sonrisa amable— y te queda ese sentimiento de insuficiencia que te
          quita el sueño.
        </p>
        <p className="font-bold text-brand-blue text-xl md:text-2xl mt-8" data-id="element-110">
          No es solo sexo; es tu orgullo y tu masculinidad los que se están
          drenando cada vez que el reloj te gana la partida.
        </p>
      </div>
    </Section>;
}